import { configureStore, isRejectedWithValue, type Middleware } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api } from '@/services/api';
import { authReducer, sessionExpired } from '@/store/authSlice';

const AUTH_ENDPOINTS = new Set(['login', 'register', 'refreshSession', 'requestPasswordReset', 'confirmPasswordReset']);

const sessionExpiryMiddleware: Middleware = (storeApi) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const status = (action.payload as { status?: number | string } | undefined)?.status;
    const endpointName = (action.meta as { arg?: { endpointName?: string } } | undefined)?.arg
      ?.endpointName;
    if (status === 401 && endpointName && !AUTH_ENDPOINTS.has(endpointName)) {
      storeApi.dispatch(sessionExpired());
    }
  }
  return next(action);
};

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    auth: authReducer
  },
  middleware: (gdm) => gdm().concat(api.middleware, sessionExpiryMiddleware)
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
